import { connect } from 'react-redux';

import Application from './Application';

import { setAppType } from '@reducers/actions';

const mapState = state => ({
  designStandard: state.main.localization.designStandard,
  appStatus: state.main.status,
  appType: state.main.appType
});

const mapDispatch = {
  setAppType
};

export default connect(mapState, mapDispatch)(Application);



// WEBPACK FOOTER //
// ./src/views/Application/index.js